import React, { useState } from 'react';
import { Button, Input, Typography, ArrowRight, ChevronRight, Edit } from '../../index';
import { useViewport } from '../../hooks/useViewport';

export const BranchOrderFooter = () => {
	const { viewport } = useViewport();
	const [branchState, setBranchState] = useState<'initial' | 'input' | 'edit'>('initial');
	const [branchNumber, setBranchNumber] = useState<string>('');

	const updateBranchNumber = () => {
		setBranchState(branchNumber === '' ? 'initial' : 'edit');
		if (branchNumber === '') {
			sessionStorage.removeItem('branchNumber');
		} else {
			sessionStorage.setItem('branchNumber', branchNumber);
		}
	};
	return (
		<div
			className={`bg-[#191919] flex w-full ${
				branchState === 'input' ? 'py-1.5' : 'py-3'
			} max-h-[56px] relative after:content-[''] after:h-px after:w-full after:bg-gray-300 after:absolute after:left-0 after:bottom-0 md:order-0`}>
			{branchState === 'initial' && (
				<Button
					variant="custom"
					size="xxs"
					style={{ paddingInline: 0 }}
					className="bg-transparent border-none w-full overflow-hidden justify-between !text-gray-darkmodeText mb-0 px-4 hover:bg-white hover:bg-opacity-[0.08] hover:rounded md:justify-start md:w-auto"
					onClick={() => setBranchState('input')}>
					{viewport === 'desktop' && <ArrowRight size="16" fill="#ccc" className="mr-2" />}Angabe zur ADAC
					Geschäftsstelle {viewport === 'mobile' && <ChevronRight fill="#ccc" />}
				</Button>
			)}
			{branchState === 'input' && (
				<>
					<Input
						basic
						size="sm"
						placeholder="Geschäftsstellennummer"
						className="!bg-[#292929] border-primary border text-white md:max-w-[268px] mr-1.5 mb-0"
						value={branchNumber}
						onChange={(ev) => {
							setBranchNumber(ev.currentTarget.value);
						}}
					/>
					<Button variant="primary" size="sm" className="mb-0 px-4" onClick={updateBranchNumber}>
						Ok
					</Button>
				</>
			)}
			{branchState === 'edit' && (
				<div
					className="flex items-center justify-between w-full cursor-pointer py-1 hover:bg-white hover:bg-opacity-[0.08] hover:rounded md:justify-start md:w-auto"
					onClick={() => setBranchState('input')}>
					<Typography size="sm" color="lightText">
						Geschäftsstelle: <span className="text-white">{branchNumber}</span>
					</Typography>
					<Button
						variant="custom"
						size="xs"
						className="bg-transparent border-none text-gray-600 !mb-0 !p-0 ml-2">
						<Edit size="24" fill="#fff" />
					</Button>
				</div>
			)}
		</div>
	);
};
